var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 12.0447C24 5.39188 18.6281 0 12 0C5.37188 0 0 5.39188 0 12.0447C0 17.6906 3.87656 22.4332 9.10312 23.7365V15.724H6.62812V12.0447H9.10312V10.4591C9.10312 6.36111 10.95 4.4603 14.9625 4.4603C15.7219 4.4603 17.0344 4.61086 17.5734 4.76142V8.09253C17.2922 8.0643 16.8 8.04548 16.1859 8.04548C14.2172 8.04548 13.4578 8.79357 13.4578 10.7367V12.0447H17.3766L16.7016 15.724H13.4531V24C19.3969 23.2801 24 18.2035 24 12.0447Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.6f9c7921f4b4f757407c643cfec03ebd.svg";
export { ForwardRef as ReactComponent };